import React from 'react';
import BenefitTrackerPage from './BenefitTrackerPage';

const OccupantSatisfaction = () => {
    return <BenefitTrackerPage benefitType='Occupant Satisfaction' title="Occupant Satisfaction" />;
};

export default OccupantSatisfaction;